/** Authorize.Net AcceptUI settings (mirrors Web.config authorizenet* appSettings on the API). */
export const authorizeNet = {
    apiLoginId: '4Z767c4hLng8',
    clientKey: '8pEdU3Fdkpk23FzC3YzXEbpRUa47Ns2UWqZ8q2jdNH3tX4UwN765Fy3Eht6zVqJ5',
    acceptUiScriptUrl: 'https://js.authorize.net/v3/AcceptUI.js'
};
